export type AuthStatus = {
  enabled: boolean;
  authenticated: boolean;
  username: string | null;
};

export class AuthError extends Error {}

async function parseAuthResponse(response: Response): Promise<AuthStatus> {
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const detail =
      body && typeof body === "object" && "detail" in body
        ? String((body as { detail: unknown }).detail)
        : "Sign in failed";
    throw new AuthError(detail);
  }
  return body as AuthStatus;
}

export async function fetchAuthStatus(): Promise<AuthStatus> {
  return fetch("/api/auth/me", { credentials: "same-origin" }).then(parseAuthResponse);
}

export async function login(username: string, password: string): Promise<AuthStatus> {
  return fetch("/api/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ username, password }),
  }).then(parseAuthResponse);
}

export async function logout(): Promise<AuthStatus> {
  return fetch("/api/auth/logout", {
    method: "POST",
    credentials: "same-origin",
  }).then(parseAuthResponse);
}
